<template>
  <div>
    <div class="grey_small_font">
      <Loading :loading="Loading" />
      <el-form label-width="110px" class="info_form">
        <van-form>
          <van-radio-group v-model="paymentType">
            <van-cell-group>
              <van-cell
                :title="$t('PAYMENTTYPE.KQ')"
                clickable
                @click="payButtonMsg('KQ')"
                v-show="cusDepProPayRule.isH5KQPay"
              >
                <template #right-icon>
                  <van-radio name="KQ" />
                </template>
              </van-cell>
              <van-cell
                :title="$t('PAYMENTTYPE.Alipay')"
                clickable
                @click="payButtonMsg('Alipay')"
                v-show="cusDepProPayRule.isH5Alipay"
              >
                <template #right-icon>
                  <van-radio name="Alipay" />
                </template>
              </van-cell>
              <van-cell
                :title="$t('PAYMENTTYPE.WeChatPay')"
                clickable
                @click="payButtonMsg('WeChatPay')"
                v-show="cusDepProPayRule.isH5WeiXinPay"
              >
                <template #right-icon>
                  <van-radio name="WeChatPay" />
                </template>
              </van-cell>
              <van-cell
                :title="$t('PAYMENTTYPE.CTA')"
                clickable
                @click="payButtonMsg('CTA')"
                v-show="cusDepProPayRule.isH5CTAPay"
              >
                <template #right-icon>
                  <van-radio name="CTA" />
                </template>
              </van-cell>
            </van-cell-group>
          </van-radio-group>
        </van-form>
      </el-form>
      <div style="color: #333;padding: 1rem;display: flex;justify-content: center;align-items: center;">
        <van-button class="button_style" v-show="cusDepProPayRule.payShowType" round block type="info" @click="payClick">{{ $t('CREDITCARD.PAYBUTTON') }}</van-button>
      </div>
    </div>
    <!-- 快钱支付选择信用卡 start -->
    <van-action-sheet
      v-model:show="showKQPaymentDialog"
      :title="$t('PAYMENTTYPE.PAYMENTTYPE')"
    >
      <div style="padding: 2rem 2rem 20rem">
        <van-cell :title="$t('PAYORDERPAGE.AddNewCard')" is-link @click="addCreditCard()" />
        <van-contact-list v-model="chooseCreditCardId" 
        :list="PayOrderInfo.creditCardInfo" 
        :add-text= "$t('CREDITCARD.PAYBUTTON')" 
        @add="creditCardPayments" 
        @edit="editCreditCard"/>
      </div>
    </van-action-sheet>
    <!-- 快钱支付选择信用卡 end -->
    <!-- 新增信用卡 start -->
    <van-popup
      v-model:show="showInvoicingDetailDialog"
      closeable
      close-icon-position="top-left"
      position="right"
      style="width: 100%; height: 100%"
    >
      <van-nav-bar :title="KQOperationTitle" :border="false" />
      <van-form ref="formRules" @submit="saveCreditCard">
        <div style="padding-top: 1rem; background-color: #f1f3f5"></div>
        <van-cell-group>
          <van-field
            readonly
            clickable
            :model-value="creditCardInfos.creditCardType"
            :label="$t('CREDITCARD.CREDITCARDTYPE')"
            @click="showCreditCardName = true"
            :rules="rules.creditCardType"
            is-link
          />
          <van-action-sheet
            v-model:show="showCreditCardName"
            :actions="PayOrderInfo.creditCardType"
            @select="onConfirmCreditCardType"
          />
          <van-field
            v-model="creditCardInfos.creditCardName"
            :label="$t('CREDITCARD.CREDITCARDNAME')"
            :rules="rules.creditCardName"
          />
          <van-field
            v-model="creditCardInfos.creditCardNo"
            :label="$t('CREDITCARD.CREDITCARDNO')"
            :rules="rules.creditCardNo"
          />
        </van-cell-group>
        <div style="padding-top: 1rem; background-color: #f1f3f5"></div>
        <van-cell-group>
          <van-field
            readonly
            clickable
            :model-value="creditCardInfos.cardType"
            :label="$t('CREDITCARD.CARDTYPE')"
            @click="showCardType = true"
            :rules="rules.cardType"
            is-link
          />
          <van-action-sheet
            v-model:show="showCardType"
            :actions="PayOrderInfo.cardType"
            @select="onConfirmCardType"
          />
          <van-field
            v-model="creditCardInfos.cardID"
            :label="$t('CREDITCARD.CARDID')"
            :rules="rules.cardID"
          />
          <van-field
            readonly
            clickable
            :model-value="creditCardInfos.bankCodeName"
            :label="$t('CREDITCARD.BANKNAME')"
            @click="showBankName = true"
            :rules="rules.bankCodeName"
            is-link
          />
          <van-action-sheet
            v-model:show="showBankName"
            :actions="toH5BanckName()"
            @select="onConfirmBankName"
          />
          <van-field
            v-model="creditCardInfos.creditCardDate"
            :label="$t('CREDITCARD.CREDITCARDDATE')"
            :rules="rules.creditCardDate"
          />
          <van-field
            v-model="creditCardInfos.mobilePhone"
            :label="$t('CREDITCARD.MOBILEPHONE')"
            :rules="rules.mobilePhone"
            type="tel"
          />
        </van-cell-group>
        <van-field :label="$t('GUARANTEE.CARDPROPERTY')">
          <template #input>
            <van-radio-group
              v-model="creditCardInfos.property"
              direction="horizontal"
            >
              <van-radio name="Company">{{
                $t("GUARANTEE.CARDPROPERTYCOM")
              }}</van-radio>
              <van-radio name="Personal">{{
                $t("GUARANTEE.CARDPROPERTYPER")
              }}</van-radio>
            </van-radio-group>
          </template>
        </van-field>
        <div style="margin: 16px">
          <van-button
            class="button_style"
            style="width: -webkit-fill-available"
            round
            block
            type="info"
            native-type="submit"
            >{{ $t("INVOICINGBUTTON.SAVE") }}</van-button
          >
          <van-button v-if="isEditCreditCard"
            class="button_style"
            style="width: -webkit-fill-available;margin-top: 2rem;"
            round
            block
            type="info"
            native-type="button"
            @click="deleteCreditCard"
            >{{ $t("INVOICINGBUTTON.DELETE") }}</van-button
          >
        </div>
      </van-form>
    </van-popup>
    <!-- 新增信用卡 end -->
    <!-- 快钱支付获取验证码 start -->
    <van-action-sheet v-model:show="showKQPaymentTcapchaDialog" :title="$t('PAYORDERPAGE.CardAuthorization')">
      <div style="padding: 2rem 2rem 20rem">
        <van-cell-group>
          <van-field
            v-model="KQPayInfo.cvv"
            :label="$t('CREDITCARD.CVV')"
            :placeholder="$t('CREDITCARD.VALIDATEMSG', {Msg: $t('CREDITCARD.CVV')})"
          />
          <van-field
            v-model="KQPayInfo.captcha"
            center
            clearable
            :label="$t('CREDITCARD.CAPTCHA')"
            :placeholder="$t('CREDITCARD.VALIDATEMSG', {Msg: $t('CREDITCARD.CAPTCHA')})"
            @update:model-value="clearNoNumCaptcha"
          >
            <template #button>
              <van-button
                size="small"
                type="primary"
                class="button_style"
                style="width: 10rem"
                @click="getTcapcha"
                :disabled="countdown > 0"
              >
                {{
                  countdown > 0
                    ? $t("CREDITCARD.GETCAPTCHA") + "(" + countdown + $t('CREDITCARD.COUNTDOWN')
                    : $t("CREDITCARD.GETCAPTCHA")
                }}
              </van-button>
            </template>
          </van-field>
        </van-cell-group>
        <div style="position: fixed; bottom: 0px; color: #333; padding: 1rem">
          <van-button class="button_style" round block type="info" @click="kqTransactionPayments" style="width: 38rem">{{ $t("PAYORDERPAGE.AgreePay") }}</van-button>
        </div>
      </div>
    </van-action-sheet>
    <!-- 快钱支付获取验证码 end -->
  </div>
</template>

<script>
import { hoteltradePay } from "@/api/bookingData.js";
import { checkCreditCard } from "@/api/platformData.js";
import Loading from "@/components/Loading.vue";
import { showConfirmDialog } from 'vant';
import { showDialog } from 'vant';
export default {
  name: "H5Pay",
  inject: ['PayOrderInfo'],
  components: {
    Loading,
  },
  props: {
    cusDepProPayRule: Object,
  },
  data() {
    var validateMonthYear = (rule, value, callback) => {
      // 验证输入的年月格式是否为 "MMYY"
      const regex = /^(0[1-9]|1[0-2])([0-9]{2})$/;
      console.log(regex.test(rule))
      return regex.test(rule);
    };
    return {
      paymentType:"",
      Loading:false,
      payInfo: {
        payTitle: "",
        payBottomMsg:"",
        aliPayInfo: "",
        currencyCode: "",
      },
      creditCardInfos: { //新增信用卡信息
        bankCodeName: "",
        bankCode: "",
        creditCardType: "",
        creditCardName: "",
        creditCardNo: "",
        cardType: "",
        cardTypeId: "",
        cardID: "",
        creditCardDate: "",
        mobilePhone: "",
        property: "Company",
        saveCard: "1",
        id:0,
      },
      KQPayInfo: { //支付的信用卡信息
        id:"",
        creditCardType: "",
        creditCardName: "",
        creditCardNo: "",
        cardType: "",
        cardID: "",
        creditCardDate: "",
        mobilePhone: "",
        captcha:"",
        cvv:"",
      },
      chooseCreditCardId: 0,
      showKQPaymentDialog:false,
      showInvoicingDetailDialog:false,
      showCreditCardName:false,
      showCardType:false,
      showBankName:false,
      showKQPaymentTcapchaDialog:false,
      signingTypeTips:this.$t('CREDITCARD.SIGNING'),
      rules:{
        bankCodeName: [{required: true,message: this.$t("CREDITCARD.VALIDATEMSG", {Msg: this.$t("CREDITCARD.BANKNAME"),}),trigger: ["blur", "change"],},],
        creditCardType: [{required: true,message: this.$t("CREDITCARD.VALIDATEMSG", {Msg: this.$t("CREDITCARD.CREDITCARDTYPE"),}),trigger: ["blur", "change"],},],
        creditCardName: [{required: true,message: this.$t("CREDITCARD.VALIDATEMSG", {Msg: this.$t("CREDITCARD.CREDITCARDNAME"),}),trigger: ["blur", "change"],},],
        creditCardNo: [{required: true,message: this.$t("CREDITCARD.VALIDATEMSG", {Msg: this.$t("CREDITCARD.CREDITCARDNO"),}),trigger: ["blur", "change"],},],
        cardType: [{required: true,message: this.$t("CREDITCARD.VALIDATEMSG", {Msg: this.$t("CREDITCARD.CARDTYPE"),}),trigger: ["blur", "change"],},],
        cardID: [{required: true,message: this.$t("CREDITCARD.VALIDATEMSG", {Msg: this.$t("CREDITCARD.CARDID"),}),trigger: ["blur", "change"],},],
        creditCardDate: [{required: true,message: this.$t("CREDITCARD.VALIDATEMSG", {Msg: this.$t("CREDITCARD.CREDITCARDDATE"),}),trigger: ["blur", "change"],},
                         {validator: validateMonthYear, message: this.$t("CREDITCARD.VALIDATECREDITCARDDATE")},           
                        ],
        mobilePhone: [{required: true,message: this.$t("CREDITCARD.VALIDATEMSG", {Msg: this.$t("CREDITCARD.MOBILEPHONE"),}),trigger: ["blur", "change"],},],
      },
      countdown:0,
      KQOperationTitle:"",
      isEditCreditCard:false,
    };
  },
  mounted() {
    // if (window.AlipayJSBridge) {
    //   callback && this.onAlipayJSBridgeReady();
    // } else {
    //   // 如果没有注入则监听注入的事件
    //   document.addEventListener('AlipayJSBridgeReady', this.onAlipayJSBridgeReady(), false);
    // }
    let createpayOrderInfo = window.sessionStorage.getItem("payOrderInfo");
    var orderInfo = this.parsePayOrderInfo(createpayOrderInfo) || this.PayOrderInfo.orderInfo;
    if (!orderInfo || !orderInfo.bookParam) {
      return;
    }
    var bookParam = orderInfo.bookParam;
    //this.payInfo.payAmount = parseFloat(bookParam.totalPrice) + parseFloat(bookParam.advancePayment) + parseFloat(bookParam.emergencyServiceFee) + parseFloat(bookParam.serviceFees.amount);
    this.payInfo.currencyCode = this.$currencySign[bookParam.currencyCode] || bookParam.currencyCode || "";
    //this.payInfo.payTitle = this.payInfo.currencyCode + this.PayOrderInfo.orderTotalPrice;
    // if(this.cusDepProPayRule.payShowType)
    // {
    //   this.paymentType=this.cusDepProPayRule.isH5Alipay?"Alipay":this.paymentType;
    //   this.paymentType=this.cusDepProPayRule.isH5WeiXinPay?"WeChatPay":this.paymentType;
    //   this.paymentType=this.cusDepProPayRule.isH5KQPay?"KQ":this.paymentType;
    //   this.payInfo.payTitle = this.$t("PAYMENTTYPE." + this.paymentType) + " " + this.payInfo.currencyCode + this.payInfo.payAmount;
    // }
  },
  watch: {
    "cusDepProPayRule.payShowType"(newVal, oldVal) {
      if (newVal && newVal != oldVal) {
        if(this.cusDepProPayRule.payShowType)
        {
          // this.paymentType=this.cusDepProPayRule.isH5Alipay?"Alipay":this.paymentType;
          // this.paymentType=this.cusDepProPayRule.isH5WeiXinPay?"WeChatPay":this.paymentType;
          // this.paymentType=this.cusDepProPayRule.isH5KQPay?"KQ":this.paymentType;
          // this.paymentType=this.cusDepProPayRule.isH5CTAPay?"CTA":this.paymentType;
          //this.payInfo.payTitle = this.$t("PAYMENTTYPE." + this.paymentType) + " " + this.payInfo.currencyCode + this.PayOrderInfo.orderTotalPrice;
        }
      }
    },
  },
  computed: {
    toH5BanckName() {
      return function () {
        var arrTemp = [];
        var list = this.PayOrderInfo.bankInfo;
        for (var i = 0; i < list.length; i++) {
          const item = {
            code: list[i].bankCode,
            name: list[i].bankName,
          };
          arrTemp.push(item);
        }
        return arrTemp;
      };
    },
    getCreditCardName(){
      return (val) => {
        var joinBank = "";
        if(val!=null && val!=undefined && val!="")
        {
          var bankInfo = this.PayOrderInfo.bankInfo.filter(function(item,index,array){
            if(item.bankCode == val.bankCode){
              return item;
            } ;
          });
          if(bankInfo.length > 0){
            joinBank = bankInfo[0].bankName.replace(val.bankCode,"") + " (" + val.creditCardNo.substr(val.creditCardNo.length - 4, 4) + ")";
          }
        }
        return joinBank;
      };
    },
  },
  methods: {
    parsePayOrderInfo(value) {
      if (!value) {
        return null;
      }
      try {
        return JSON.parse(value);
      } catch (error) {
        console.log("支付订单信息解析失败:", error);
        return null;
      }
    },
    payButtonMsg(val) {
      const payGatewayMap = {
        Alipay: "Hotel_Alipay",
        WeChatPay: "Hotel_WeiXinPay",
        KQ: "Hotel_CNY_ProtocolPay",
        CTA: "Hotel_CNY_ProtocolPay_CTA",
      };
      const payGateway = payGatewayMap[val] || "";
      if (payGateway) {
        this.PayOrderInfo.getSwipeRates(payGateway);
      }
      this.paymentType = val;
      //this.payInfo.payTitle = this.$t("PAYMENTTYPE." + this.paymentType) + " " + this.payInfo.currencyCode + this.PayOrderInfo.orderTotalPrice;
    },
    payClick() {
      if (this.paymentType == "") {
        showDialog({
          message: this.$t("BOOKING.CHOOSENTYPE"),
          theme: 'round-button',
        });
        return;
      }
      //判断那种支付方式
      if (this.paymentType == "Alipay") {
        //支付宝
        this.AliPay();
      } else if (this.paymentType == "WeChatPay") {
        //微信
        this.WeChatPay();
      } else if (this.paymentType == "KQ"){
        //快钱
        this.KQPay();
      }else if (this.paymentType == "CTA"){
        //快钱_CTA
        this.KQCTAPay();
      }
    },
    //支付宝支付
    AliPay() {
      this.paymentCompletionAlert();
      let token = localStorage.getItem(
        "token_" + (new URLSearchParams(location.search).get("sourceType") ? new URLSearchParams(location.search).get("sourceType") : sessionStorage.getItem("pathSource"))
      );
      //var url = "https://hltht.uat.mycwt.com.cn/payment/payment.aspx?Recid=2993";
      var url = window.location.origin + "/hotel/booking/v1/hoteltrade/AliPay?bookingCode="+ this.PayOrderInfo.orderInfo.bookParam.bookingId + "&channel=2&token=" +token;
      //var url = "https://localhost:44308/v1/hoteltrade/AliPay?bookingCode="+ this.PayOrderInfo.orderInfo.bookParam.bookingId + "&token=" ;//+token;
      location.href = url;
      // this.Loading=true;
      // let Params = {
      //   BookingCode: this.PayOrderInfo.orderInfo.bookParam.bookingId,
      //   SourceType: "H5",
      //   Channel: 2,
      // };
      // let that = this;
      // // this.$router.push({
      // //   name: "AliPay",
      // //   query: {
      // //     BookingCode: this.PayOrderInfo.orderInfo.bookParam.bookingId,
      // //   },
      // // });
      // //window.open('https://roomit.uat.mycwt.com.cn/pay/H5/AliPay?BookingCode='+ this.PayOrderInfo.orderInfo.bookParam.bookingId+"token=",'about:blank');
      // hoteltradePay(Params)
      //   .then(function (response) {
      //     that.Loading=false;
      //     if (response.code == "200") {
      //       if (response.data.code == "0") {
      //         // window.location.href = response.data.body;
      //         const div = document.createElement('div')
      //         /* 此处form就是后台返回接收到的数据 */
      //         div.innerHTML = response.data.body;
      //         div.id = 'alipay'
      //         document.body.appendChild(div)
      //         document.querySelector('#alipay').children[0].submit() // 执行后会唤起支付宝
      //       } else {
      //         that.Loading=false;
      //       }
      //     } else {
      //       that.Loading=false;
      //     }
      //   })
      //   .catch(function (error) {
      //     console.log(error);
      //     that.Loading=false;
      //   });
    },
    //微信支付
    WeChatPay() {
      //this.paymentCompletionAlert();
      let token = localStorage.getItem(
        "token_" + (new URLSearchParams(location.search).get("sourceType") ? new URLSearchParams(location.search).get("sourceType") : sessionStorage.getItem("pathSource"))
      );
      //var url = "https://hltht.uat.mycwt.com.cn/payment/payment.aspx?Recid=2993";
      var url = window.location.origin + "/hotel/booking/v1/hoteltrade/WeChatPay?bookingCode="+ this.PayOrderInfo.orderInfo.bookParam.bookingId + "&channel=3&token=" +token;
      //var url = "https://localhost:44308/v1/hoteltrade/AliPay?bookingCode="+ this.PayOrderInfo.orderInfo.bookParam.bookingId + "&token=" ;//+token;
      location.href = url;
      // let Params = {
      //   BookingCode: this.PayOrderInfo.orderInfo.bookParam.bookingId,
      //   SourceType: "H5",
      //   Channel: 3,
      // };
      // let that = this;
      // hoteltradePay(Params)
      //   .then(function (response) {
      //     that.Loading=false;
      //     if (response.code == "200") {
      //       if (response.data.code == "0") {
      //         that.paymentCompletionAlert();
      //         // const div = document.createElement('div')
      //         // /* 此处form就是后台返回接收到的数据 */
      //         // div.innerHTML = response.data.body;
      //         // document.body.appendChild(div);
      //         // document.forms[0].submit();
      //         if (top.location != self.location) {
      //             top.location.href = decodeURIComponent(response.data.body);
      //         }
      //         else {
      //             location.href = decodeURIComponent(response.data.body);
      //         }
      //         //window.location.href = decodeURIComponent(response.data.body);
      //       } else {
      //         that.Loading=false;
      //       }
      //     } else {
      //       that.Loading=false;
      //     }
      //   })
      //   .catch(function (error) {
      //     console.log(error);
      //     that.Loading=false;
      //   });
    },
    KQPay() {
      this.showKQPaymentDialog = true;
      this.showInvoicingDetailDialog = false;
      //this.KQPayInfo = this.PayOrderInfo.creditCardInfo[0];
      if(this.PayOrderInfo.creditCardInfo[0] != undefined){
        this.KQPayInfo = this.PayOrderInfo.creditCardInfo[0];
      }
    },
    KQCTAPay() {
      this.PayOrderInfo.openLoading();
      let checkParams = {
        params: {
          creditCardNo: this.PayOrderInfo.orderInfo.bookParam.paymentInfo.airplusUatp,
          userCode: this.PayOrderInfo.orderInfo.bookParam.customerCode,
        },
      };
      checkCreditCard(checkParams).then((response) => {
        if (response.code == "200") {
          if(response.data){
            let Params = {
              BookingCode: this.PayOrderInfo.orderInfo.bookParam.bookingId,
              SourceType: "PC",
              Channel: 5,
              BankCardNo:this.PayOrderInfo.orderInfo.bookParam.paymentInfo.airplusUatp,
            };
            let that = this;
            hoteltradePay(Params).then(function (response) {
              if (response.code == "200") {
                if (response.data.code == "0") {
                  showDialog({
                    message: that.$t("PAYORDERPAGE.PaymentSucceeded"),
                    theme: 'round-button',
                  });
                  that.PayOrderInfo.closeLoading();
                } else {
                  showDialog({
                    message:  response.data.msg,
                    theme: 'round-button',
                  });
                  that.PayOrderInfo.closeLoading();
                }
              } else {
                showDialog({
                  message: that.$t("PAYORDERPAGE.PaymentFailed"),
                  theme: 'round-button',
                });
                that.PayOrderInfo.closeLoading();
              }
            });
          } else {
            showDialog({
              message: this.$t("PAYORDERPAGE.CTACheckMsg"),
              theme: 'round-button',
            });
            this.PayOrderInfo.closeLoading();
          }
        } else {
          showDialog({
            message: this.$t("PAYORDERPAGE.CTACheckMsg"),
            theme: 'round-button',
          });
          this.PayOrderInfo.closeLoading();
        }
      });
    },
    bankCodeChange(val) {
      var arr = this.PayOrderInfo.creditCardInfo.filter(function(item,index,array){
        if(item.id == val){
          return item;
        } ;
      });
      this.PayOrderInfo.kqContractToken = "";
      //this.KQPayInfo = this.$options.data().KQPayInfo;
      this.KQPayInfo = arr[0];
      this.creditCardNo = arr.creditCardNo;
      let Param = {
        params: {
          userCreditCardId: this.KQPayInfo.id,
          source:"H5",
        },
      };
      this.PayOrderInfo.verifyBankSigning(Param);
    },
    addCreditCard() {
      Object.assign(this.$data.creditCardInfos, this.$options.data.call(this).creditCardInfos)
      this.KQOperationTitle = this.$t('PAYORDERPAGE.AddCreditCard');
      this.showInvoicingDetailDialog = true;
      this.isEditCreditCard= false;
    },
    saveCreditCard() {
      const bookParam = this.PayOrderInfo.orderInfo?.bookParam;
      if (!bookParam) {
        return;
      }
      const data = {
        source:"H5",
        userCode: bookParam.customerCode,
        userId: this.KQPayInfo.userID,
        creditCardName: this.creditCardInfos.creditCardName,
        creditCardNo: this.creditCardInfos.creditCardNo,
        creditCardDate: this.creditCardInfos.creditCardDate,
        creditCardType: this.creditCardInfos.creditCardType,
        bankCode: this.creditCardInfos.bankCode,
        mobilePhone: this.creditCardInfos.mobilePhone,
        natureCode: this.creditCardInfos.property,
        cardType: this.creditCardInfos.cardTypeId,
        cardID: this.creditCardInfos.cardID,
        saveData: true,//默认保存，不保存的先不做
        createBy: bookParam.createdBy,
        loginID: bookParam.bookingAgent?.[0]?.userId || "",
        bankCodeName: this.creditCardInfos.bankCodeName,
        id:this.creditCardInfos.id,
        isFirst:true,
      };
      this.PayOrderInfo.addUserCreditCardCallBack(data);
    },
    getTcapcha(){
      this.countdown = 59;
      this.PayOrderInfo.tcapchaTimer = setInterval(()=>{
        if(this.countdown >0){
          this.countdown --;
        }else{
          clearInterval(this.PayOrderInfo.tcapchaTimer)
          this.PayOrderInfo.tcapchaTimer = null;
        }
      },1000);
      let data = {
        source:"H5",
        id:this.KQPayInfo.id,
        bookingId: this.PayOrderInfo.orderInfo.bookParam.bookingId,
        cardHolderId: this.PayOrderInfo.orderInfo.bookParam.bookingAgent[0].userId,
        cvv: this.KQPayInfo.cvv,
        customerCode:this.PayOrderInfo.orderInfo.bookParam.customerCode,
      };
      this.PayOrderInfo.kqContract(data);
    },
    kqTransactionPayments(){
      var payStatus = true;
      this.Loading=true;
      let Params = {
        BookingCode: this.PayOrderInfo.orderInfo.bookParam.bookingId,
        SourceType: "PC",
        Channel: 4,
        Id:this.KQPayInfo.id,
        cardHolderId: this.PayOrderInfo.orderInfo.bookParam.bookingAgent[0].userId,
      };
      if(!this.PayOrderInfo.isSigning){
        if(this.KQPayInfo.captcha == "" || this.KQPayInfo.captcha == undefined){
          showDialog({
            message: this.$t('CREDITCARD.VALIDATEMSG', {Msg: $t('CREDITCARD.CAPTCHA')}),
            theme: 'round-button',
          });
          payStatus = false;
        }
        Params.ValidCode = this.KQPayInfo.captcha;
        Params.Token = this.PayOrderInfo.kqContractToken;
      };
      if(payStatus){
        let that = this;
        that.pcPayLoading= true;
        hoteltradePay(Params)
          .then(function (response) {
            if (response.code == "200") {
              if (response.data.code == "0") {
                showDialog({
                  message: that.$t("PAYORDERPAGE.PaymentSucceeded"),
                  theme: 'round-button',
                });
              } else {
                showDialog({
                  message:  response.data.msg,
                  theme: 'round-button',
                });
              }
            } else {
              showDialog({
                message: that.$t("PAYORDERPAGE.PaymentFailed"),
                theme: 'round-button',
              });
            }
            that.pcPayLoading= false;
            that.Loading=false;
          });
      }
    },
    clearNoNumCaptcha() {
      this.KQPayInfo.captcha = this.KQPayInfo.captcha.toString().replace(/\D/g, '');
    },
    onConfirmCreditCardType(value) {
      this.creditCardInfos.creditCardType = value.name;
      this.showCreditCardName = false;
    },
    onConfirmCardType(value) {
      this.creditCardInfos.cardTypeId = value.id;
      this.creditCardInfos.cardType = value.name;
      this.showCardType = false;
    },
    onConfirmBankName(value) {
      this.creditCardInfos.bankCodeName = value.name;
      this.creditCardInfos.bankCode = value.code;
      this.showBankName = false;
    },
    creditCardPayments(){
      this.bankCodeChange(this.chooseCreditCardId);
    },
    verifyBankSigningCallBack(){
      if(!this.PayOrderInfo.isSigning){
        this.showKQPaymentTcapchaDialog = true;
      }else{
        this.kqTransactionPayments();
      }
    },
    editCreditCard(contact){
      this.KQOperationTitle = this.$t('PAYORDERPAGE.EditCreditCard');
      this.isEditCreditCard= true;
      this.showInvoicingDetailDialog = true;
      var creditCardType = this.PayOrderInfo.creditCardType.filter(function(item){
        if(item.value == contact.creditCardType){
          return item;
        } ;
      });
      var cardType = this.PayOrderInfo.cardType.filter(function(item){
        if(item.id == contact.cardType){
          return item;
        } ;
      });
      this.creditCardInfos.creditCardType = creditCardType[0].id;
      this.creditCardInfos.creditCardName = contact.creditCardName;
      this.creditCardInfos.creditCardNo = contact.creditCardNo;
      this.creditCardInfos.cardType = cardType[0].name;
      this.creditCardInfos.cardTypeId = contact.cardType;
      this.creditCardInfos.cardID = contact.cardID;
      this.creditCardInfos.bankCodeName = contact.name;
      this.creditCardInfos.creditCardDate = contact.creditCardDate;
      this.creditCardInfos.mobilePhone = contact.mobilePhone;
      this.creditCardInfos.natureCode = contact.natureCode;
      this.creditCardInfos.bankCode = contact.bankCode;
      this.creditCardInfos.id = contact.id;
    },
    deleteCreditCard(){
      showConfirmDialog({
        message: this.$t("INVOICINGINFO.DELETEMSG"),
        confirmButtonText: this.$t("INVOICINGBUTTON.CONFIRM"),
        cancelButtonText: this.$t("INVOICINGBUTTON.CANCEL"),
      })
      .then(() => {
        let data = {
          source:"H5",
          userCode: this.PayOrderInfo.orderInfo.bookParam.customerCode,
          userId: this.KQPayInfo.userID,
          creditCardName: this.creditCardInfos.creditCardName,
          creditCardNo: this.creditCardInfos.creditCardNo,
          creditCardDate: this.creditCardInfos.creditCardDate,
          creditCardType: this.creditCardInfos.creditCardType,
          bankCode: this.creditCardInfos.bankCode,
          mobilePhone: this.creditCardInfos.mobilePhone,
          natureCode: this.creditCardInfos.property,
          cardType: this.creditCardInfos.cardTypeId,
          cardID: this.creditCardInfos.cardID,
          saveData: true,//默认保存，不保存的先不做
          createBy: this.PayOrderInfo.orderInfo.bookParam.createdBy,
          loginID: this.PayOrderInfo.orderInfo.bookParam.bookingAgent[0].userId,
          bankCodeName: this.creditCardInfos.bankCodeName,
          id:this.creditCardInfos.id,
          isFirst:true,
        };
        this.PayOrderInfo.deleteUserCreditCardCallBack(data);
      });
    },
    paymentCompletionAlert(){
      showConfirmDialog({
        message: this.$t("PAYORDERPAGE.PaymentAlert"),
        confirmButtonText: this.$t("PAYORDERPAGE.PaymentAlertYes"),
        cancelButtonText: this.$t("PAYORDERPAGE.PaymentAlertNo"),
      })
      .then(() => {
        this.PayOrderInfo.orderDetail();
      });
    }
  },
};
</script>

<style scoped>
.info_form {
  background-color: white;
  margin: 1rem 1rem 0 1rem;
  border-radius: 1rem;
}
.button_style {
  width: 43rem;
  background-color: #fc6640;
  border: 1px solid #fc6640;
}
.van-field__label{
  width: 10.2em!important;
}
.van-contact-list__bottom
{
  background-color: unset;
}
.van-button--danger
{
  background-color: #fc6640!important;
  border: 1px solid #fc6640!important;
}
::v-deep .van-radio__icon--checked .van-icon
{
  background-color: #fc6640!important;
  border: 1px solid #fc6640!important;
}
</style>